<template>
  <div class="animated fadeIn faster">
    <h2 class="siimple--text-center siimple-h2 siimple--mb-5">
      <span v-if="!isNovanet">Statistikk</span>
      <span v-if="isNovanet">Novanet Statistikk</span>
    </h2>
    <spinner v-if="isLoading" />
    <div v-if="!isLoading">
      <p><strong>Hvor mange har klart de forskjellige nøttene?</strong></p>
      <div class="siimple-table">
        <div class="siimple-table-header">
          <div class="siimple-table-row">
            <div class="siimple-table-cell">Nøtt</div>
            <div class="siimple-table-cell siimple--text-right">Antall</div>
            <div class="siimple-table-cell siimple--text-right">Prosent</div>
          </div>
        </div>
        <div class="siimple-table-body">
          <div v-for="(dist, index) in pointDistribution" :key="index" class="siimple-table-row">
            <div class="siimple-table-cell">
              <emoji v-for="(emoji, index) in toEmojiArray(dist.text)" :key="index" :value="emoji" />
            </div>
            <div class="siimple-table-cell siimple--text-right">
              {{ dist.count }}
            </div>
            <div class="siimple-table-cell siimple--text-right">
              {{ getPercentage(dist.count) }} %
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/utils/http-common';
import Spinner from '@/components/Spinner';
import Emoji from '@/components/Emoji';
import GraphemeSplitter from 'grapheme-splitter';

const splitter = new GraphemeSplitter();

export default {
  name: 'Statistics',
  components: {
    Spinner,
    Emoji
  },
  props: {
    isNovanet: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      numberOfParticipants: null,
      pointDistribution: [],
      isLoadingParticipants: true,
      isLoadingPointDistribution: true
    };
  },
  computed: {
    isLoading() {
      return this.isLoadingParticipants || this.isLoadingPointDistribution;
    }
  },
  mounted() {
    this.getParticipants();
    this.getPointDistribution();
  },
  methods: {
    getPercentage(count) {
      return this.numberOfParticipants > 0
        ? ((count / this.numberOfParticipants) * 100).toFixed(0)
        : 0;
    },
    getParticipants() {
      const url = this.isNovanet
        ? 'statistics/participants/novanet'
        : 'statistics/participants';
      HTTP.get(url)
        .then(response => {
          this.numberOfParticipants = response.data;
          this.isLoadingParticipants = false;
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.error(e);
          this.isLoadingParticipants = false;
        });
    },
    getPointDistribution() {
      const url = this.isNovanet
        ? 'statistics/answers/distribution/novanet'
        : 'statistics/answers/distribution';
      HTTP.get(url)
        .then(response => {
          this.pointDistribution = response.data;
          this.isLoadingPointDistribution = false;
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.error(e);
          this.isLoadingPointDistribution = false;
        });
    },
    toEmojiArray(emojis) {
      return splitter.splitGraphemes(emojis);
    }
  }
};
</script>

<style scoped>
.siimple-table-body .siimple-table-cell {
  padding-bottom: 8px;
  padding-top: 12px;
  line-height: 34px;
}

@media (max-width: 480px) {
  .siimple-table-cell.mobile-only {
    display: table-cell;
  }

  .siimple-table-cell.desktop-only {
    display: none;
  }

  /* Make sure all input fields are at least 16px on mobile due to ios autozoom feature */
  .siimple-input {
    font-size: 16px;
  }
}

@media (min-width: 481px) {
  .siimple-table-cell.mobile-only {
    display: none;
  }

  .siimple-table-cell.desktop-only {
    display: table-cell;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics.vue